import React from 'react';
import { Monitor, Smartphone, Wrench, Zap, Printer, Home, Wifi, Joystick } from 'lucide-react';

const icons = {
  laptop: Monitor,
  smartphone: Smartphone,
  wrench: Wrench,
  rocket: Zap,
  printer: Printer,
  settings: Wrench,
  home: Home,
  wifi: Wifi,
  joystick: Joystick,
};

const Icon = ({ name, ...props }) => {
  const LucideIcon = icons[name];
  return LucideIcon ? <LucideIcon {...props} /> : null;
};

export default Icon;
